import React, { JSX, useState } from 'react';

import { NotificationAlert } from '../components/notification';

type IconType = 'notifications' | 'chat_bubble' | 'warning' | 'chat';

type NotificationPosition =
  | 'top-start'
  | 'top-center'
  | 'top-end'
  | 'middle-start'
  | 'middle-center'
  | 'middle-end'
  | 'bottom-start'
  | 'bottom-center'
  | 'bottom-end';

export interface NotificationContent {
  message: JSX.Element | string;
  icon: IconType;
  isHide: boolean;
  onCloseCallback?: () => void; // if someone need callback once notification vanish or user click close button
}

interface NotificationState {
  position: NotificationPosition;
  content: NotificationContent[];
}

const initialNotificationState: NotificationState = {
  position: 'bottom-end',
  content: []
};

const NotificationContext = React.createContext<
  [
    initialState: NotificationState,
    setState: React.Dispatch<React.SetStateAction<NotificationState>>
  ]
>([initialNotificationState, () => {}]);

const NotificationProvider = (props: any) => {
  const [state, setState] = useState<NotificationState>({
    ...initialNotificationState
  });

  return (
    <NotificationContext.Provider value={[state, setState]}>
      {props.children}
      <NotificationAlert />
    </NotificationContext.Provider>
  );
};

export { NotificationContext, NotificationProvider };
